<template>
  <centered-layout :showFooter="true">
    <status :stepStatuses="stepStatuses" @click="onClick">
      <heading level="2" class="title" slot="title">{{ $t('congratulations.title') }}</heading>
      <div class="description" slot="description">{{ $t('congratulations.description') }}</div>
      <span slot="buttonLabel">{{ $t('congratulations.button') }}</span>
    </status>
  </centered-layout>
</template>

<script>
import Status from '@/components/Status';
import CenteredLayout from '@/views/layouts/CenteredLayout';
import { COMPLETE } from '@/constants/application-step-statuses';
import { mapActions } from 'vuex';
import applicationMixin from '@/mixins/application';
import { createNewThreatMetrixScript } from '@/analytics/threatmetrix';

export default {
  components: {
    CenteredLayout,
    Status,
  },
  mixins: [applicationMixin],
  data() {
    return {
      stepStatuses: [COMPLETE, COMPLETE, COMPLETE],
    };
  },
  async created() {
    if (this.application._extension.isBLASigned === undefined) {
      await this.updateThreatMetrixSessionId();
      createNewThreatMetrixScript();
      await this.$store.dispatch('application/fetchApplication');
      this.application._extension.isBLASigned = true;
      await this.updateApplication(this.generatePatch());
    }
  },
  methods: {
    ...mapActions('application', ['updateThreatMetrixSessionId']),
    onClick() {
      window.location.assign(this.$env.VUE_APP_CUSTOMER_PORTAL_URL);
    },
  },
};
</script>
<style lang="sass" scoped></style>
